export default "__VITE_ASSET__1938bbb8__"